const defaults = {
    dataAttr: 'data-clipboard-text'
};

class Clipboard {
    constructor(link, option) {
        this.options = Object.assign({}, defaults, option);
        link.addEventListener('click', (evt) => this.copy(evt));
    }

    createHiddenControl() {
        const input = document.createElement('input');
        input.classList.add('visually-hidden');
        document.body.appendChild(input);
        return input;
    }

    copy(evt) {
        evt.preventDefault();

        const input = this.createHiddenControl();

        input.value = evt.target.getAttribute(this.options.dataAttr);
        input.focus();
        input.select();
        document.execCommand('copy');

        document.body.removeChild(input);
    }
}

function init(elms, option) {
    [].forEach.call(elms, (link) => {
        link.clipboard = new Clipboard(link, option);
    });
}

export default {
    init
};
